export const webPageCity = [
    {
        "url_name": "auburn-hills-property-management",
        "page_title": "Auburn Hills Property Management",
        "city_id":26
    },
    {
        "url_name": "berkley-property-management",
        "page_title": "Berkley Property Management",
        "city_id":27
    },
    {
        "url_name": "beverly-hills-property-management",
        "page_title": "Beverly Hills Property Management",
        "city_id":95
    },
    {
        "url_name": "birmingham-property-management",
        "page_title": "Birmingham Property Management",
        "city_id":29
    },
    {
        "url_name": "bloomfield-hills-property-management",
        "page_title": "Bloomfield Hills Property Management",
        "city_id":31
    },
    {
        "url_name": "bloomfield-township-property-management",
        "page_title": "Bloomfield Property Management",
        "city_id":30
    },
    {
        "url_name": "canton-property-management",
        "page_title": "Canton Property Management",
        "city_id":115
    },
    {
        "url_name": "center-line-property-management",
        "page_title": "Center Line Property Management",
        "city_id":68
    },
    {
        "url_name": "chesterfield-township-property-management",
        "page_title": "Chesterfield Property Management",
        "city_id":69
    },
    {
        "url_name": "clarkston-property-management",
        "page_title": "Clarkston Property Management",
        "city_id":142
    },
    {
        "url_name": "clinton-township-property-management",
        "page_title": "Clinton Property Management",
        "city_id":70
    },
    {
        "url_name": "commerce-township-property-management",
        "page_title": "Commerce Property Management",
        "city_id":104
    },
    {
        "url_name": "farmington-hills-property-management",
        "page_title": "Farmington Hills Property Management",
        "city_id":19
    },
    {
        "url_name": "fenton-property-management",
        "page_title": "Fenton Property Management",
        "city_id":96
    },
    {
        "url_name": "franklin-property-management",
        "page_title": "Franklin Property Management",
        "city_id":34
    },
    {
        "url_name": "fraser-property-management",
        "page_title": "Fraser Property Management",
        "city_id":72
    },
    {
        "url_name": "grand-blanc-property-management",
        "page_title": "Grand Blanc Property Management",
        "city_id":17
    },
    {
        "url_name": "harper-woods-property-management",
        "page_title": "Harper Woods Property Management",
        "city_id":91
    },
    {
        "url_name": "harrison-township-property-management",
        "page_title": "Harrison Property Management",
        "city_id":73
    },
    {
        "url_name": "hazel-park-property-management",
        "page_title": "Hazel Park Property Management",
        "city_id":36
    },
    {
        "url_name": "highland-township-property-management",
        "page_title": "Highland Property Management",
        "city_id":37
    },
    {
        "url_name": "holly-property-management",
        "page_title": "Holly Property Management",
        "city_id":38
    },
    {
        "url_name": "inkster-property-management",
        "page_title": "Inkster Property Management",
        "city_id":120
    },
    {
        "url_name": "lake-orion-property-management",
        "page_title": "Lake Orion Property Management",
        "city_id":42
    },
    {
        "url_name": "livonia-property-management",
        "page_title": "Livonia Property Management",
        "city_id":92
    },
    {
        "url_name": "macomb-property-management",
        "page_title": "Macomb Property Management",
        "city_id":118
    },
    {
        "url_name": "madison-heights-property-management",
        "page_title": "Madison Heights Property Management",
        "city_id":46
    },
    {
        "url_name": "milford-property-management",
        "page_title": "Milford Property Management",
        "city_id":47
    },
    {
        "url_name": "northville-property-management",
        "page_title": "Northville Property Management",
        "city_id":48
    },
    {
        "url_name": "oak-park-property-management",
        "page_title": "Oak Park Property Management",
        "city_id":50
    },
    {
        "url_name": "plymouth-property-management",
        "page_title": "Plymouth Property Management",
        "city_id":125
    },
    {
        "url_name": "pontiac-property-management",
        "page_title": "Pontiac Property Management",
        "city_id":25
    },
    {
        "url_name": "royal-oak-property-management",
        "page_title": "Royal Oak Property Management",
        "city_id":7
    },
    {
        "url_name": "troy-property-management",
        "page_title": "Troy Property Management",
        "city_id":62
    },
    {
        "url_name": "warren-property-management",
        "page_title": "Warren Property Management",
        "city_id":3
    },
    {
        "url_name": "waterford-property-management",
        "page_title": "Waterford Property Management",
        "city_id":14
    },
    {
        "url_name": "west-bloomfield-property-management",
        "page_title": "West Bloomfield Property Management",
        "city_id":21
    },
    {
        "url_name": "white-lake-property-management",
        "page_title": "White Lake Property Management",
        "city_id":16
    },
]
